var swiperfeatured = new Swiper(".inner__content--reright", {
    slidesPerView: 1,
    spaceBetween: 40,
    grid: {
        rows: 1,
        fill:"rows",
      },    
    breakpoints: {
        
        768: {
            grid: {
                rows: 3,
                fill:"rows",
              },          
        },
        
      },
    scrollbar: {
        el: ".swiper-scrollbar.featured",
       draggable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next.featured",
        prevEl: ".swiper-button-prev.featured",
      },
  
   
   
  });